<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-13                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-form-group v-bind="$props">
    <b-form-input v-model="item[field]"
                  :placeholder="placeholder"
                  :disabled="disabled"
                  :required="required"
                  :type="type"
                  :step="step"
                  :pattern="pattern"
                  @change="$emit('change',$event)"
                  @input="$emit('input',$event)">

    </b-form-input>
  </b-form-group>

</template>

<script>
import MixinIsFormGroup from "./mixin-is-form-group";

export default {
name: "yega1-form-group-input",
  emits: ['input', 'change'],
  mixins:[
    MixinIsFormGroup
  ],
  props:{
    type:{
      type:String,
      default:'text'
    },
    placeholder:{
      type:String,
      default(props){
        return `Enter ${props.label}`;
      }
    },
    step:{
      type: String
    },
    pattern:{
      type:String
    }
  }
}
</script>

<style scoped>

</style>
